import MDP from "@/components/MDP";

export default class NotesListMDP implements MDP {
    componentName: string = "NotesList";
    customerDetails: any;
    notesAdded: () => void;
    constructor(props: {customerDetails: any;notesAdded: () => void;}) {
        this.customerDetails = props.customerDetails;
        this.notesAdded = props.notesAdded;
    }

    getMetaData(): object {
        return {
            componentName: this.componentName,
            props: {
                customerDetailsNotes: this.customerDetails,
                notesAdded: this.notesAdded
            }
            
        }
    }
}